import React, { useRef, useState, useEffect } from 'react';
import "@aws-amplify/ui-react/styles.css";
//import "semantic-ui-css/semantic.min.css"
import { Link, useNavigate} from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownItem, DropdownDivider } from 'semantic-ui-react'
import { Hub } from 'aws-amplify';
import './ui_views/CommonStyles.css';

import appLogo from "./images/workgpt_128.png";
import copyImage from "./images/copy.png";
import settingsImage from "./images/settings.png"
import settingsWhiteImage from "./images/settings_white.png"
import historyImage from "./images/history.png";
import rocketloadingImage from "./images/rocket.gif";

//import {LANGUAGE_MAP} from "./utils/LanguageMap.js";
import * as AuthUtils from './utils/AuthUtils.js';
import * as ReactUtils from "./utils/ReactUtils.js";
import * as Utils from './utils/Utils.js';

import CreateImage from './ui_views/CreateImage';
import EditImage from './ui_views/EditImage';
import ChatPDF from './ui_views/ChatPDF';
import AskAI from './ui_views/AskAI'

const EDIT_OR_READ_CONTENT_MENU_ID = "editOrReadContentMenuId";
const CREATE_CONTENT_MENU_ID = "createContentMenuId";
const ASK_GPT_MENU_ID = "askGPTMenuId";
const CREATE_IMAGE_MENU_ID = "createImageMenuId";
const EDIT_IMAGE_MENU_ID = "editImageMenuId";
const CHAT_IMAGE_MENU_ID = "chatImageMenuId";
const OCR_MENU_ID = "ocrMenuId";
const CHAT_PDF_DOC_MENU_ID  = "chatPDFDocMenuId";

const MENU_TEXT_MAP = {
  [EDIT_OR_READ_CONTENT_MENU_ID]: 'General Work AI',
  [CREATE_CONTENT_MENU_ID]: 'Write',
  [ASK_GPT_MENU_ID]: 'Chat AI',
  [CREATE_IMAGE_MENU_ID]: 'Create Image & Logo', 
  [EDIT_IMAGE_MENU_ID]: 'Edit Image',
  [CHAT_IMAGE_MENU_ID]: 'Chat Image',
  [OCR_MENU_ID]: 'OCR',
  [CHAT_PDF_DOC_MENU_ID]: 'ChatPDF & ChatDOC',
};

const INPUT_TEXT_PLACEHOLDER = {
  EDIT_READ_CONTENT: "Enter your text (e.g. look forward to see you.)",
  CREATE_CONTENT: "What to create? (e.g. Write a 200-word essay on global warming. Write a blog, tweet, LinkedIn post, or video caption about [])",
  ASK_GPT: "What questions do you want to ask WorkGPT directly?"
}

const WORKGPT_CHROME_URL = 'https://chrome.google.com/webstore/detail/workgpt-gpt-for-work/aijkbfcgfacnbgaladlemlbonnddphdf';
const WORKGPT_FOR_WORKSPACE_URL= "https://workspace.google.com/marketplace/app/workgpt_gpt_chatgpt_for_workspace/368806015202";
const EMAIL_AI_URL = "https://workspace.google.com/marketplace/app/emailai_gpt_chatgpt_ai_for_email_and_gma/244071321454";
const TRANSLATE_GPT_FOR_WORKSPACE_URL = "https://aiworksuite.com/translator-with-gpt";
const CONTACT_US_URL = "https://www.aiworksuite.com/contact-us"

function listenToSignUpSignInEvents() {
  Hub.listen('auth', async (data) => {
    // eslint-disable-next-line default-case
    switch (data.payload.event) {
      case 'signIn':
          console.debug('user signed in', data.payload.data?.attributes?.email);
          try {
            let user = await AuthUtils.currentAuthenticatedUser();
            if (!user.attributes['custom:origin_platform']) {
              let result = await AuthUtils.updateUserAttributes(user, { 'custom:origin_platform': Utils.PLATFORM_TYPE.WEB });
              console.debug('User attributes updated:', result);
            }
          } catch (error) {
              console.error('Error updating user orgin platform attribute:', error);
          }
          break;
      case 'signUp':
        console.debug('user signed up', data.payload.data?.attributes?.email);
        break;
      case 'signOut':
        console.debug('user signed out');
          break;
      case 'signIn_failure':
          console.log('user sign in failed');
          break;
      case 'configured':
          console.log('the Auth module is configured');
    }
  });  
}

export const DashboardPage = () => {
  listenToSignUpSignInEvents();
  const [inputTextValue, setInputTextValue] = 
    useState(Utils.getLocalStorageProperty(Utils.SETTINGS_AUTO_SAVED_INPUT_CONTENT) || '');
  const [lastActionSelected, setLastActionSelected] = useState(
      Utils.getLocalStorageProperty(Utils.SETTINGS_LAST_ACTION_SELECTED) ?? Utils.DEFAULT_ACTION_SELECTED);
  const [additionalContext, setAdditionalContext] = useState(
      Utils.getLocalStorageProperty(Utils.SETTINGS_LAST_ADDITIONAL_CONTEXT) ?? Utils.DEFAULT_ADDITIONAL_CONTEXT);
  const [additionalContextHint, setAdditionalContextHint]= useState(Utils.getAdditionalContextHint(lastActionSelected));
  const [additionalContextSuggestions, setAdditionalContextSuggestions] = useState(Utils.getAdditionalContextSuggestions(lastActionSelected));
  
  const handleInputTextChange = (event) => {    
    setInputTextValue(event.target.value); 
    Utils.setLocalStorageProperty(Utils.SETTINGS_AUTO_SAVED_INPUT_CONTENT, event.target.value);
  };
  const handleActionToTakeChange = (event) => {
    const actionSelected = event.target.value;
    setLastActionSelected(actionSelected);
    setAdditionalContext("");
    setAdditionalContextHint(Utils.getAdditionalContextHint(actionSelected));
    setAdditionalContextSuggestions(Utils.getAdditionalContextSuggestions(actionSelected));
    //console.log("additionalContextSuggestions", actionSelected, lastActionSelected, (Utils.getAdditionalContextSuggestions(actionSelected)));

    Utils.setLocalStorageProperty(Utils.SETTINGS_LAST_ACTION_SELECTED, actionSelected);
  };
  const handleAdditionalContextChange = (event) => {
    const additionalContext = event.target.value;
    setAdditionalContext(additionalContext);
    Utils.setLocalStorageProperty(Utils.SETTINGS_LAST_ADDITIONAL_CONTEXT, additionalContext);
  };

  const handleInputTextOnClick = (event) => {
    if (activeMenuItem === CREATE_CONTENT_MENU_ID) {
      const $suggestionDivElement = document.getElementById('createContentSuggestionsDivId');
      Utils.showHTMLElement($suggestionDivElement);
      event.stopPropagation();
    }
  }

  const initialMenuId = Utils.getLocalStorageProperty(Utils.SETTINGS_LAST_ACTIVE_MENU_ID) ?? Utils.DEFAULT_MAIN_MENU_ID_SELECTED;
  const [activeMenuItem, setActiveMenuItem] = useState(initialMenuId);
  const [subPageTitle, updateSubPageTitle] = useState(MENU_TEXT_MAP[initialMenuId]);
  const handleMainMenuItemClick = (event) => {
    setActiveMenuItem(event.target.id);
    updateSubPageTitle(MENU_TEXT_MAP[event.target.id])
    Utils.setLocalStorageProperty(Utils.SETTINGS_LAST_ACTIVE_MENU_ID, event.target.id);
  };

  const handleCreateContentActionSuggestionClick = (actionSuggestion) => {
    setInputTextValue(actionSuggestion);
    Utils.hideHTMLElement(document.getElementById('createContentSuggestionsDivId'));
  };

  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [gptOutputValue, setGptOutputValue] = useState(`Hello, please enter the text above and click the submit button.`);
  //const gptOutputTextElementRef = useRef(null);
  const onCopyGPTOutputText = () => {
    navigator.clipboard.writeText(gptOutputValue);
  }
  const [gptOutputDivTextColor, setGptOutputDivTextColor] = useState('black');

  const [isMenuSidebarOpen, setIsMenuSidebarOpen] = useState(false);
  const onMenuSidebarClick = () => {
    //console.log("onMenuSidebarClick get clicked");
    setIsMenuSidebarOpen(!isMenuSidebarOpen);
  }
  const sidebarMenuRef = useRef(null);
  const handleOutsideOfSidebarMenuClick = (event) => {
    //console.log("handleOutsideOfSidebarMenuClick get clicked", event.target.id);
    if (sidebarMenuRef.current && !sidebarMenuRef.current.contains(event.target) && event.target.id !== "sideBarMenuId") {
      setIsMenuSidebarOpen(false);
    }
  };

  const premiumSectionRef = useRef(null);
  const onScrollToPremiumSection = () => {
    premiumSectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  const aboutSectionRef = useRef(null);
  const onScrollToAboutSection = () => {
    aboutSectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const [isUserSignedIn, setIsUserSignedIn] = useState(false);
  const [isUserSubscribed, setIsUserSubscribed] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [loggedInUserId, setLoggedInUserId] = useState('');
  const [profileImageUrl, setProfileImageUrl] = useState('');
  useEffect(() => { 
    updateUserSignedInStateAndEmail(); 
    {  


      // document.addEventListener('click', function(event) {
      //   if (!event.target.matches('.dropbtn')) {
      //     var dropdowns = document.getElementsByClassName("dropdown-content");
      //     var i;
      //     for (i = 0; i < dropdowns.length; i++) {
      //       var openDropdown = dropdowns[i];
      //       if (openDropdown.classList.contains('show')) {
      //         openDropdown.classList.remove('show');
      //       }
      //     }
      //   }        
      // });
    }

    // document.addEventListener('click', handleOutsideOfSidebarMenuClick);
    // return () => {
    //   document.removeEventListener('click', handleOutsideOfSidebarMenuClick);
    // };
  }, []);

  const [openAccountDropDown, setOpenAccountDropDown] = useState(false);
  const accountDropdowntrigger = (
    <span onClick={() => setOpenAccountDropDown(!openAccountDropDown)}>
      <img src={appLogo} alt="account logo" className="ui avatar image" style={{ cursor: 'pointer', marginTop: '2px'}}/>
    </span>
  );


  const [upgradeToPremiumLabelText, setUpgradeToPremiumLabelText] = useState(
    'You have credits remaining and the limit for GPT requests is 2 per minute. To enjoy unlimited usage and a significantly higher request limit, please Upgrade to Premium service through the UPGRADE button below.');
  const [upgradeToPremiumLabelTextColor, setUpgradeToPremiumLabelTextColor] = useState('gray');
  const updatePremiumLabelTextAndSubmitButton = (leftCredits, isSubscribed) => {
    if (isSubscribed) {
      setUpgradeToPremiumLabelText("");
    } else if (leftCredits < 5) {
      setUpgradeToPremiumLabelText("You have only " + leftCredits + " credits remaining. Upgrade to the Premium service now to get unlimited use without request limit!");
      setUpgradeToPremiumLabelTextColor("red");
    } else {
      setUpgradeToPremiumLabelText("You have " + leftCredits + " credits remaining and the limit for GPT requests is 2 per minute. To enjoy unlimited usage and a significantly higher request limit, UPGRADE to our Premium service through the button below.");
      setUpgradeToPremiumLabelTextColor("gray");
    }

    setSubmitButtonDisabled((!isSubscribed) && (leftCredits <= 0));
  }

  const updateUserSignedInStateAndEmail = async () => {
    const user = await AuthUtils.currentAuthenticatedUser();
    if (user) {
      const session = await AuthUtils.currentSession();
      const accessToken = session?.getAccessToken()?.getJwtToken();

      if (accessToken) {
        setAccessToken(accessToken);
        setIsUserSignedIn(true);
        setLoggedInUserId(user.attributes?.sub);
        setProfileImageUrl(user.attributes?.image);

        const userInfo = await AuthUtils.currentUserInfo();
        if (userInfo?.attributes?.email) {
          setUserEmail(userInfo?.attributes?.email);
        }

        const subscriptionState = await Utils.getSubscriptionState();
        //console.log("subscription state", subscriptionState, Utils.isUserSubscribed(subscriptionState));
        setIsUserSubscribed(Utils.isUserSubscribed(subscriptionState));

        const leftCredits = Utils.getNumberOfLeftGPTCredits();
        updatePremiumLabelTextAndSubmitButton(leftCredits, Utils.isUserSubscribed(subscriptionState));
        return
      }
    }

    setAccessToken('');
    setIsUserSignedIn(false);
    setLoggedInUserId('');
    setProfileImageUrl('');
  };

  const [isShowLoadingDimmer, setIsShowLoadingDimmer] = useState(false);

  const onClickSignup = async () => {
    window.location.href = "https://progpt.ai";
    // const $gptSection = document.getElementById("gptSectionId");
    // ReactUtils.showUserSignInOrOutPopup(null, $gptSection, true, updateUserSignedInStateAndEmail);
  }

  const onClickLogin = async () => {
    const $gptSection = document.getElementById("gptSectionId");
    ReactUtils.showUserSignInOrOutPopup(null, $gptSection, false, updateUserSignedInStateAndEmail);
  }

  const navigate = useNavigate();
  const onShowHistoryButtonClick = () => {
    if (isUserSubscribed) {
      navigate('/history');
    } else {
      ReactUtils.PurchasePremiumPopup(document.getElementById('workGPT_inputTextFieldId'), userEmail);
    }
  }

  const navigateToChromeExtension = () => {
    window.open(WORKGPT_CHROME_URL);
  };

  const navigateToURL= (url) => {
    window.open(url);
  };

  async function askGPT() {
    if (isUserSignedIn) {
      if (accessToken) {
        try {
          const isExceedRequestLimitEveryMin = await Utils.getIsExcceedRequestLimitEveryMin();
          if (isExceedRequestLimitEveryMin) {
            setGptOutputValue("You have exceeded the request rate limit per minute with free version. Please retry after a couple of mins or Upgrade to our Premium Service package below with unlimited usage and much longer translation support!");
            setGptOutputDivTextColor('red');
            return;
          }
          
          setIsShowLoadingDimmer(true);
          const prompt = Utils.getPreSetPromptFromSettings() 
            + Utils.getGPTPromptFromInput(inputTextValue, lastActionSelected, additionalContext);
          const gptResponse = await Utils.askGPTHttp(accessToken, prompt);
          
          console.debug("GPT response is", gptResponse);
          setIsShowLoadingDimmer(false);

          setGptOutputValue(gptResponse.gptResponse);
          setGptOutputDivTextColor('black');

          Utils.setSubscriptionState(gptResponse.subscriptionState);

          if (gptResponse.gptResponse) {
            Utils.setLastGPTRequestTimeStamp();
            Utils.increaseDailyRequest();

            if (!Utils.isUserSubscribed(gptResponse.subscriptionState)) {
              const leftCredits = Utils.decrementNumberOfLeftCredits();
              updatePremiumLabelTextAndSubmitButton(leftCredits, false);
            }

            await Utils.addToGPTHistory(gptResponse.gptResponse);
          }
        } catch(error) {
          console.error("Get GPT text failed", error.message);
          setIsShowLoadingDimmer(false);
          setGptOutputValue("Get GPT response failed: " + error.message);
          setGptOutputDivTextColor('red');
        }
      } else {
        console.error("onClickAskGPTutton(): get session token failed for user");
        const $gptSection = document.getElementById("gptSectionId");
        ReactUtils.showUserSignInOrOutPopup(null, $gptSection, false, updateUserSignedInStateAndEmail);
      }
    } else {
      console.log("onClickAskGPTutton(): no authenticated user found");
      const $gptSection = document.getElementById("gptSectionId");
      ReactUtils.showUserSignInOrOutPopup(null, $gptSection, true, updateUserSignedInStateAndEmail);
    }
  }

  function clear() {
    setInputTextValue('');
    Utils.setLocalStorageProperty(Utils.SETTINGS_AUTO_SAVED_INPUT_CONTENT, '');
    setGptOutputValue('');
  }

  return (<div>
    <meta charSet="utf-8" />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/water.css@2/out/water.css"></link>
    <title>WorkGPT: GPT for Workspace, GPT for Docs, GPT for Slides, GPT for Sheets, GPT for Gmail, GPT for Chrome</title>

    <style type="text/css">
      {Styles()}
    </style>

    {/* Your JavaScript script here */}

    <div className="ui inverted left fixed vertical menu" style={{width: '250px', display: 'flex', flexDirection: 'column'}}>
      <div className="item">
        <img className="ui mini image" src={appLogo} style={{display: 'inline'}}/>
        <div style={{ marginLeft: '15px', fontSize: '17px', display: 'inline', fontWeight: '600', fontFamily: "Arial, sans-serif", color: '#FFF' }}>WorkGPT</div>
      </div>
      <a className={`item ${activeMenuItem === EDIT_OR_READ_CONTENT_MENU_ID ? 'active' : ''}`} id={EDIT_OR_READ_CONTENT_MENU_ID}
        onClick={(event) => handleMainMenuItemClick(event)} >{MENU_TEXT_MAP[EDIT_OR_READ_CONTENT_MENU_ID]}</a>
      <a className={`item ${activeMenuItem === ASK_GPT_MENU_ID ? 'active' : ''}`} 
            id={ASK_GPT_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[ASK_GPT_MENU_ID]}</a>
      <a className={`item ${activeMenuItem === CREATE_CONTENT_MENU_ID ? 'active blue' : ''}`} 
            id={CREATE_CONTENT_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[CREATE_CONTENT_MENU_ID]}</a>
      <div className="item">
        <div className="header">Image</div>
        <div className="menu">
          <a className={`item ${activeMenuItem === CREATE_IMAGE_MENU_ID ? 'active blue' : ''}`} 
            id={CREATE_IMAGE_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[CREATE_IMAGE_MENU_ID]}</a>
          <a className={`item ${activeMenuItem === EDIT_IMAGE_MENU_ID ? 'active blue' : ''}`} 
            id={EDIT_IMAGE_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[EDIT_IMAGE_MENU_ID]}</a>
          <a className={`item ${activeMenuItem === OCR_MENU_ID ? 'active blue' : ''}`} 
            id={OCR_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[OCR_MENU_ID]}</a>
          <a className={`item ${activeMenuItem === CHAT_IMAGE_MENU_ID ? 'active blue' : ''}`} 
            id={CHAT_IMAGE_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[CHAT_IMAGE_MENU_ID]}</a>
        </div>
      </div>
      <div className="item">
        <div className="header">Other Tools</div>
        <div className="menu">
        <a className={`item ${activeMenuItem === CHAT_PDF_DOC_MENU_ID ? 'active blue' : ''}`} 
            id={CHAT_PDF_DOC_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>{MENU_TEXT_MAP[CHAT_PDF_DOC_MENU_ID]}</a>
          <a className="item">Create PPT</a>
          {/* <a className="item">Chat Video</a>
          <a className="item">Chat Audio</a> */}
          {/* <a className="item">Chat Website</a> */}
        </div>
      </div>
      <div className="item">
        <div className="header">History</div>
        <div className="menu">
        </div>
      </div>

      {/* style={{position: 'absolute', bottom: '10px', left: '20%', transform: 'translateX(-20%)' }} */}

      <div id="menuItems" style={{marginTop: 'auto', padding: '0 16px 10px'}}>
         { isUserSignedIn && (!isUserSubscribed) && <div>
            <div className="ui divider"></div>
            <label id="upgradeToPremiumTextId" style={{ color: upgradeToPremiumLabelTextColor, marginBottom: '10px'}}>
              {upgradeToPremiumLabelText}
            </label>
            <button id="upgradeButtonId" className="ui purple button" style={{marginBottom: '14px'}}
                onClick={ (event) => { ReactUtils.PurchasePremiumPopup(event.target, userEmail);  } }>
                <b>Upgrade to Premium</b> 
            </button>
        </div> }

        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          { isUserSignedIn && <Dropdown trigger={accountDropdowntrigger} open={openAccountDropDown} 
            onClose={() => setOpenAccountDropDown(false)} onOpen={() => setOpenAccountDropDown(true)}>
            <Dropdown.Menu>
              <Dropdown.Header style={{textTransform: 'none', fontSize: '14px'}}> 
                <img src={appLogo} className="ui avatar image" style={{ cursor: 'pointer', marginRight: '6px'}}/>
                {userEmail}</Dropdown.Header>
              <Dropdown.Divider/>
              <Dropdown.Item icon="arrow alternate circle down" text="Download iOS App/extension/addon!" />
              <Dropdown.Item icon="comment alternate" text="Feedback" />
              <Dropdown.Item icon="sign-out" text="Logout" />
            </Dropdown.Menu>
          </Dropdown> }
          <button class="ui icon button small inverted red" 
            data-tooltip="Install and use WorkGPT addon and extension, and mobile app now!" data-inverted="" 
            data-variation="tiny" data-position="top left" style={{marginLeft: 'auto'}}>
            <i class="app store ios icon"></i>
            <i class="chrome icon"></i>
            <i class="google icon"></i>
          </button>
          <button class="ui icon button small inverted noboxShadow" data-tooltip="Have any question or need help? Contact us" 
            data-inverted="" data-variation="tiny" data-position="top left">
            <i class="envelope outline icon"></i>
          </button>
          <Link to="/settings">
            <button id="settingsButtonId" style={{ padding: '4px', backgroundColor: '#000000', transform: 'translateY(4px)' }} 
              data-tooltip="Settings" data-inverted="" data-variation="tiny" data-position="top center">
              <img id="settingsButtonImageId" src={settingsWhiteImage} style={{ width: '18px' }} alt="" />
            </button> 
          </Link>
        </div>
      </div>
    </div>

    {/* <div className="ui container" >
      <a className="active item default-font-family" href="https://www.aiworksuite.com">Home</a>
        <a className="item default-font-family" onClick={onScrollToAboutSection}>About</a>
        {isUserSignedIn && (!isUserSubscribed) && <a className="item default-font-family" onClick={onScrollToPremiumSection}>Premium Plan</a>}

        <Dropdown text='Products' item className="default-font-family">
          <Dropdown.Menu>
            <Dropdown.Item text='WorkGPT: GPT for Google Workspace' onClick={() => navigateToURL(WORKGPT_FOR_WORKSPACE_URL)} />
            <Dropdown.Item text='WorkGPT for Chrome' onClick={navigateToChromeExtension} />
            <Dropdown.Item text='EmailAI' onClick={() => navigateToURL(EMAIL_AI_URL)} />
            <Dropdown.Item text='TranslateGPT' onClick={() => navigateToURL(TRANSLATE_GPT_FOR_WORKSPACE_URL)} />
          </Dropdown.Menu>
        </Dropdown>

        <a className="item default-font-family" href={CONTACT_US_URL}>Help Center</a>
    </div> */} 

    <div>
      <div id="gptSectionId" className="default-font-famil" style={{padding: '20px 10px 20px 16px'}}>
        <div style={{fontSize: '19px', fontWeight: '600', display: 'inline-block', marginTop: '4px', color: 'rgb(0, 122, 255)'}}>{subPageTitle}</div>
        <div style={{paddingBottom: '5px', display: 'inline-block', float: 'right'}}>
          { !isUserSignedIn 
            && <a className="ui button" style={{ backgroundColor: 'rgb(167, 52, 222)', color: 'white'}} onClick={onClickSignup}>Start Now</a> }
          { !isUserSignedIn 
            && <a className="ui button" style={{ marginLeft: '10px'}} onClick={onClickLogin}>Login</a> }
          { isUserSignedIn && (!isUserSubscribed) && <div>
                {/* <button style={{ padding: '4px', marginTop: '5px', backgroundColor: '#F6F8FF' }} data-tooltip="GPT History" 
                  data-inverted="" data-variation="tiny" data-position="bottom center" onClick={onShowHistoryButtonClick}>
                  <img src={historyImage} style={{ width: '18px' }} alt="" />
                </button> */}
                <button style={{ padding: '7px', marginTop: '5px', backgroundColor: 'rgb(147, 0, 255)', 
                  transform: 'translateY(-4px)', color: 'white', fontWeight: '500' }} data-tooltip="Premium Service" 
                  data-inverted="" data-variation="tiny" data-position="bottom center" onClick={ (event) => { ReactUtils.PurchasePremiumPopup(event.target, userEmail); }}  >
                 {'\u2728 Premium'}
                </button>

              {/* <Dropdown style={{width: '50px', border: 'none', backgroundColor: 'transparent'}}
                placeholder='Option'
                selection
                options={[
                  { key: 1, text: 'GPT-3.5', value: 1 },
                  { key: 2, text: 'GPT-4', value: 2 },
                  { key: 3, text: 'Option 3', value: 3 },
                  // Add more options here
                ]}
              /> */}

              {/* <div class="ui selection dropdown">
                <input type="hidden" name="gender"></input>
                <i class="dropdown icon"></i>
                <div class="default text">Gender</div>
                <div class="menu">
                  <div class="item" data-value="1">Male</div>
                  <div class="item" data-value="0">Female</div>
                </div>
              </div> */}

              {/* <Link to="/settings">
                <button id="settingsButtonId" style={{ padding: '4px', marginTop: '5px', backgroundColor: '#F6F8FF' }} 
                  data-tooltip="Settings" data-inverted="" data-variation="tiny" data-position="bottom center">
                  <img id="settingsButtonImageId" src={settingsImage} style={{ width: '18px' }} alt="" />
                </button> 
              </Link> */}
            </div>}
        </div>
        <div className="ui divider"></div>

        {/* <div className="ui secondary three pointing menu" id="workGPT_gptMainMenuId">
          <a className={`item blue ${activeMenuItem === EDIT_OR_READ_CONTENT_MENU_ID ? 'active' : ''}`} 
            id={EDIT_OR_READ_CONTENT_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>Edit or Read Content</a>
          <a className={`item blue ${activeMenuItem === CREATE_CONTENT_MENU_ID ? 'active' : ''}`} 
            id={CREATE_CONTENT_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>Create Content</a>
          <a className={`item blue ${activeMenuItem === ASK_GPT_MENU_ID ? 'active' : ''}`} 
            id={ASK_GPT_MENU_ID} onClick={(event) => handleMainMenuItemClick(event)}>Ask GPT</a>
        </div> */}

        { ((activeMenuItem === EDIT_OR_READ_CONTENT_MENU_ID) || (activeMenuItem === CREATE_CONTENT_MENU_ID) ) && <div>
          <div id="inputSectionId">
            <textarea id="workGPT_inputTextFieldId" className='custom-textarea'
              style={{ height: '200px', marginTop: '6px' }}
              value={inputTextValue} onChange={handleInputTextChange} onClick={handleInputTextOnClick}
              placeholder={`${(activeMenuItem === CREATE_CONTENT_MENU_ID) ? INPUT_TEXT_PLACEHOLDER.CREATE_CONTENT 
                  : ((activeMenuItem === ASK_GPT_MENU_ID) ? INPUT_TEXT_PLACEHOLDER.ASK_GPT 
                    : INPUT_TEXT_PLACEHOLDER.EDIT_READ_CONTENT)}`}></textarea>
            <div id="createContentSuggestionsDivId" className="suggestions-container" style={{ display: 'none', width: '280px' }}>
                <ul id="createContentSuggestionsListId">
                {Object.values(Utils.CREATE_CONTENT_ACTION_SUGGESTIONS).map((actionSuggestion, index) => (
                  <li key={index} onClick={() => handleCreateContentActionSuggestionClick(actionSuggestion)}>
                    {actionSuggestion}
                  </li>
                ))}
                </ul>
            </div>
            <div style={{ marginBottom: '10px' }}></div>

            <div id="loadingDimmer" className={`ui inverted dimmer ${isShowLoadingDimmer ? 'active' : ''}`}>
                <div className="ui indeterminate text loader"></div>
                <img src={rocketloadingImage} style={{width: "24px", marginTop: "-12px"}} alt="rocket" />
            </div>

            { (activeMenuItem === EDIT_OR_READ_CONTENT_MENU_ID) && <div id="workGPT_actionToTakeSelectionSectionId">
                <label style={{ color: 'gray', paddingRight: '5px' }}>2. Action to take</label>
                <select id="workGPT_actionSelectionId" style={{ display: 'inline' }}
                  value={lastActionSelected} onChange={handleActionToTakeChange}>
                {Object.entries(Utils.ACTION_TO_TAKE).map(([_, value]) => (<option key={value} value={value}>{value}</option>
            ))}</select></div> }

            { (activeMenuItem === EDIT_OR_READ_CONTENT_MENU_ID) && 
              <div id="workGPT_additionalContextSectionId" style={{ marginTop: '8px', marginBottom: '15px' }}>
                <div id="workGPT_additionalContextLabelDivId" style={{ color: 'gray', paddingRight: '5px', marginBottom: '5px' }}>
                  {additionalContextHint}</div>
                <input type="text" id="workGPT_additionalContextInputId" style={{minWidth: '400px'}} 
                  list="workGPT_additionalContextSuggestionsId" value={additionalContext} onChange={handleAdditionalContextChange}/>
                <datalist id="workGPT_additionalContextSuggestionsId">
                  {additionalContextSuggestions.map((option, index) => (<option key={index} value={option} />))}</datalist>
              </div>}
          </div>

          <button id="askGPTButtonId" className="primary-button" onClick={askGPT} disabled={submitButtonDisabled}>
            <b>Submit and Ask GPT</b>
          </button>
          <button id="clearButtonId" className="" onClick={clear}>Clear</button>

          <div className="ui divider"></div>
          <div>
            <label style={{ color: 'gray', paddingBottom: '5px' }}>From AI GPT</label>
            <button id="copyResultTextButtonId" type="button" onClick={onCopyGPTOutputText}
                style={{ display: 'inline', padding: '2px', float: 'right', marginTop: '8px' }}
                  data-tooltip="Copy" data-inverted="" data-variation="tiny" data-position="bottom center">
                <img src={copyImage} style={{ width: '18px' }} alt="copyButton" />
            </button>
          </div>
          <div id="gptOutputTextId" contentEditable="true" style={{ minHeight: '140px', whiteSpace: 'pre-wrap', color: gptOutputDivTextColor }} 
            suppressContentEditableWarning={true} >{gptOutputValue}</div>
        </div> }


        <div style={{display: (activeMenuItem === ASK_GPT_MENU_ID) ? 'contents' : 'none'}}>
          <AskAI isUserSignedIn={isUserSignedIn} isUserSubscribed={isUserSubscribed} loggedInUserId={loggedInUserId}
            accessToken={accessToken} loggedInUserAvatar={profileImageUrl}></AskAI>
        </div>


        {/* https://stackoverflow.com/questions/75854404/react-components-hiding-showing-without-re-renders */}
        <div style={{display: (activeMenuItem === CREATE_IMAGE_MENU_ID) ? 'contents' : 'none'}}>
          <CreateImage isUserSignedIn={isUserSignedIn} isUserSubscribed={isUserSubscribed} userEmail={userEmail} accessToken={accessToken}></CreateImage>
        </div>
        <div style={{display: (activeMenuItem === EDIT_IMAGE_MENU_ID) ? 'contents' : 'none'}}>
          <EditImage isUserSignedIn={isUserSignedIn} isUserSubscribed={isUserSubscribed} 
            accessToken={accessToken} loggedInUserId={loggedInUserId}></EditImage>
        </div>

        <div style={{display: (activeMenuItem === CHAT_PDF_DOC_MENU_ID) ? 'contents' : 'none'}}>
          <ChatPDF isUserSignedIn={isUserSignedIn} isUserSubscribed={isUserSubscribed}></ChatPDF>
        </div>

        {/* { isUserSignedIn && (!isUserSubscribed) && <div>
            <div className="ui divider"></div>
            <label id="upgradeToPremiumTextId" style={{ color: upgradeToPremiumLabelTextColor, marginTop: '20px', marginBottom: '20px'}}>
              {upgradeToPremiumLabelText}
            </label>
            <button id="upgradeButtonId" className="ui purple button large" 
                    onClick={ (event) => { ReactUtils.PurchasePremiumPopup(event.target, userEmail);  } }>
                    <b>Upgrade to Premium Service</b> 
            </button>
        </div> } */}
        
        { isUserSignedIn && (!isUserSubscribed) && <div>
            <script async
              src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6740757017179116"
              crossOrigin="anonymous"></script>
            <ins className="adsbygoogle"
              style={{ display: 'block' }}
              data-ad-client="ca-pub-6740757017179116"
              data-ad-slot="4356616512"
              data-ad-format="auto"
              data-full-width-responsive="true"
              onClick={() => {
                // Handle the click event here
                console.log('Adsbygoogle element clicked');
              }}
            ></ins>
            <script>
                (adsbygoogle = window.adsbygoogle || []).push({});
            </script>
        </div>}

      </div>
    </div>

  </div>
  );
}

// padding: 10px;
// border-bottom: 1px solid #ccc;


// .ui.vertical.menu .menu .item {
//   cursor: pointer;
//   font-family: Arial, sans-serif;
//   color: #FFFFFF;
// }

// .sidebar {
//   width: 250px;
//   position: fixed;
//   left: 0;
//   top: 0;
//   bottom: 0;
//   background-color: #fff;
//   box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
//   padding: 10px;
// }

// style="margin-left: 250px;
// margin-bottom: 0px;
// padding: 20px 30px;
// background-color: #F6F8FF;
// height: 100%;
// border-radius: 12px;
// overflow: auto;"


    {/* <div class="ui vertical menu">
      <div class="item">
        <div class="header">Products</div>
        <div class="menu">
          <a class="item">Enterprise</a>
          <a class="item">Consumer</a>
        </div>
      </div>
      <div class="item">
        <div class="header">CMS Solutions</div>
        <div class="menu">
          <a class="item">Rails</a>
          <a class="item">Python</a>
          <a class="item">PHP</a>
        </div>
      </div>
      <div class="item">
        <div class="header">Hosting</div>
        <div class="menu">
          <a class="item">Shared</a>
          <a class="item">Dedicated</a>
        </div>
      </div>
      <div class="item">
        <div class="header">Support</div>
        <div class="menu">
          <a class="item">E-mail Support</a>
          <a class="item">FAQs</a>
        </div>
      </div>
    </div> */}

    {/* <div className="sidebar">
      <div className="sidebar-item">
        <img className="sidebar-logo" src="/path-to-your-logo.png" alt="Logo" />
      </div>
      <div className="sidebar-item">
        <input type="text" placeholder="Chat" />
      </div>
      <div className="sidebar-item">Write</div>
      <div className="sidebar-item">Translate</div>
      <div className="sidebar-item">Ask</div>
      <div className="sidebar-item">OCR</div>
      <div className="sidebar-item">Grammar</div>
      <div className="sidebar-item">Painter</div>
      <div className="sidebar-item">ChatPDF</div>
    </div> */}

          
    // .sidebar-item {
    //   cursor: pointer;
    //   font-family: Arial, sans-serif;
    //   color: #FFFFFF; !important;
    // }
    
    // .sidebar-logo {
    //   width: 100%;
    //   /* Adjust as needed for your logo */
    // }
    
    // input[type="text"] {
    //   width: 100%;
    //   padding: 5px;
    //   margin: 5px 0;
    // }

const Styles = () => (
  <style>
    {`
      body {
        margin: 0px 0px 0px 250px;
        background-color: #F6F8FF;
        height: 100vh;
        border-radius: 12px;
        overflow: auto;
        max-width: 100%
      }

      .ui.vertical.menu .item {
        cursor: pointer;
        font-size: medium
      }

      .ui.vertical.menu .item>.header:not(.ui) {
        color: gray;
      }

      .ui.inverted.vertical.menu .menu .item {
        cursor: pointer;
        color: #FFFFFF;
      }

      .ui.left.inverted.vertical.menu .active.item:hover,
      .ui.menu .active.item:hover {
        background-color: rgba(0, 0, 0, 0.03);
      }

      .ui.inverted.vertical.menu .item .item:hover {
        background-color: #ff0000; /* Change this to the desired hover color */
        color: #ff0000 !important; /* Optional: Change the text color on hover */
      }

      .ui.inverted.menu .active.item {
        color: #2185d0 !important
      }

      img[src=""] {
        display: none !important;
      }

      .video-container {
        position: relative;
        width: 100%;
        height: '0';
        padding-bottom: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
      }

      .default-font {
        font-size: 19px;
        font-family: Helvetica, arial, sans-serif; 
      }

      .default-font-family {
        font-family: Helvetica, arial, sans-serif; 
      }
      
      /* Then style the iframe to fit in the container div with full height and width */
      .video-container iframe {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .centered {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .hidden.menu {
        display: none;
      }

      .masthead.segment {
        min-height: 700px;
        padding: 1em 0em;
      }
      .masthead .logo.item img {
        margin-right: 1em;
      }
      .masthead .ui.menu .ui.button {
        margin-left: 0.5em;
      }
      .masthead h1.ui.header {
        margin-top: 3em;
        margin-bottom: 0em;
        font-size: 4em;
        font-weight: normal;
      }
      .masthead h2 {
        font-size: 1.7em;
        font-weight: normal;
      }

      .ui.vertical.stripe {
        padding: 8em 0em;
      }
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .ui.vertical.stripe .button + h3,
      .ui.vertical.stripe p + h3 {
        margin-top: 3em;
      }
      .ui.vertical.stripe .floated.image {
        clear: both;
      }
      .ui.vertical.stripe p {
        font-size: 1.33em;
      }
      .ui.vertical.stripe .horizontal.divider {
        margin: 3em 0em;
      }

      .quote.stripe.segment {
        padding: 0em;
      }
      .quote.stripe.segment .grid .column {
        padding-top: 5em;
        padding-bottom: 5em;
      }

      .footer.segment {
        padding: 5em 0em;
      }

      .secondary.pointing.menu .toc.item {
        display: none;
      }

      .custom-textarea {
        min-width: 450px !important; /* Adjust the value as needed */
      }

      .custom-marginleft {
        margin-left: 60px; !important;
      }

      .suggestions-container {
        border: 1px solid #ccc;
        padding: 5px;
        position: absolute;
        background-color: white;
        width: 300px;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
        z-index: 1000;
      }
      
      .suggestions-container ul {
          list-style: none;
          padding: 0;
          margin: 0;
      }
      
      .suggestions-container li {
          padding: 5px;
          cursor: pointer;
      }
      
      .suggestions-container li:hover {
          background-color: #f0f0f0;
      }

      .ui.inverted.button.noboxShadow {
        box-shadow: none !important;
      }

      @media only screen and (max-width: 700px) {
        .ui.fixed.menu {
          display: none !important;
        }
        .secondary.large.menu .item,
        .secondary.large.menu .button,
        .secondary.large.menu .menu {
          display: none;
        }
        .secondary.large.menu .toc.item {
          display: block;
        }
        .masthead.segment {
          min-height: 350px;
        }
        .masthead h1.ui.header {
          font-size: 2em;
          margin-top: 1.5em;
        }
        .masthead h2 {
          margin-top: 0.5em;
          font-size: 1.5em;
        }

        .custom-textarea {
          /* Default height for larger screens */
          min-width: 100% !important;
        }

        .custom-marginleft {
          margin-left: 0px;
        }
      }
    `}
  </style>
);


/* 
1. Create Content suggestions and more prompts (Done)
2. Sign up with Google (Done)
3. Todo: add create images functionality 

  } else if (request[utils.MESSAGE_TYPE_KEY] == utils.MESSAGE_TYPE.GPT_CREATE_IMAGE) {
    (async () => {
      try {
        if (request[utils.SEND_MESSAGE_GPT_PROMPT]) {  
          const requestData = {
            prompt: request[utils.SEND_MESSAGE_GPT_PROMPT],
            type: GPT_REQUEST_TYPE.CREATE_IMAGE,
            imageSize: request[utils.SEND_MESSAGE_IMAGE_SIZE],
            accessToken: request[utils.SEND_MESSAGE_ACCESS_TOKEN],
            surface: utils.SURFACE_TYPE.CHROME_EXT,
          };

          const response = await awsClient.fetch(`${ASK_GPT_URL}/my-lambda/invocations`, 
            { body: JSON.stringify(requestData) });
          const gptResponse = await response.json();

          console.log("gpt create image response is", gptResponse);
          sendResponse({[utils.SEND_MESSAGE_RESPONSE]: gptResponse.imageURL});
        } else {
          console.error("gpt create image prompt is null", JSON.stringify(request));
        }
      } catch(error) {
        console.error("Create image prompt failed");
        sendResponse({[utils.SEND_MESSAGE_ERROR_RESPONSE]: "Create image failed: " + error.message});
      }
    })();

4. Show GPT-4


*/
